
const translatable =
`
  defaultLocale,
    value{
      key,
      value
    },
`;

export default translatable;